/*
 * Coupon Messages
 *
 * This contains all the text for the Coupon component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.CouponList';

export default defineMessages({
  create: {
    id: `${scope}.create`,
    defaultMessage: 'Create coupon',
  },
  update: {
    id: `${scope}.update`,
    defaultMessage: 'Update coupon',
  },
  firstToAdd: {
    id: `${scope}.firstToAdd`,
    defaultMessage: 'Be first to add coupon',
  },
  createSuccess: {
    id: `${scope}.createSuccess`,
    defaultMessage: 'Coupon is created successfully',
  },
  updateSuccess: {
    id: `${scope}.updateSuccess`,
    defaultMessage: 'Coupon is updated successfully',
  },
  deleteSuccess: {
    id: `${scope}.deleteSuccess`,
    defaultMessage: 'Coupon is deleted successfully',
  },
  deleteTitle: {
    id: `${scope}.deleteTitle`,
    defaultMessage: 'Do you want to delete the coupon?',
  },
  deleteWarn: {
    id: `${scope}.deleteWarn`,
    defaultMessage: 'This coupon is assigned to some of the team',
  },
});
